module.exports = __webpack_public_path__ + "img/exam-bg.4b8f2363.png";